import { getEnvVar } from '@studio/environment/getEnvVar';

//Webpack expose a global variable called __webpack_public_path__ that allows you to set publicUrl during runtime.
//Refer https://webpack.js.org/guides/public-path/

/* eslint-disable import/first */
if (!!getEnvVar('REACT_APP_PUBLIC_URL')) {
  // eslint-disable-next-line no-undef
  __webpack_public_path__ = getEnvVar('REACT_APP_PUBLIC_URL');
}
import './wdyr';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { Provider as ReduxProvider, ReactReduxContext } from 'react-redux';
import { ConnectedRouter } from 'connected-react-router';
import { AppErrorBoundary } from '@shoflo/polymer';

import App from './App';
import { createConfiguredStore } from './store';
import {
  getUserFromSession,
  getViewPermissions
} from '@shoflo/studio-redux/actions';

import * as serviceWorker from './serviceWorker';

import './bootstrap-combined.scss';
import './index.css';
import '@shoflo/polymer/dist/styles/custom-fonts.css';
import { logEventLoopLag } from '@studio/logger/datadog/logEventLoopLag';
import { initRUM } from '@studio/logger/datadog/initRum';
import packageJSON from '../package.json';

const { version, name: appName } = packageJSON;

const { store, history } = createConfiguredStore();
logEventLoopLag();
initRUM(appName, version);

const reduxDevModeCheckFrequency =
  process.env.NODE_ENV === 'development' ? 'always' : 'never';
const root = createRoot(document.getElementById('root'));
root.render(
  <AppErrorBoundary>
    <ReduxProvider store={store} context={ReactReduxContext}>
      <ConnectedRouter
        history={history}
        context={ReactReduxContext}
        noopCheck={reduxDevModeCheckFrequency}
      >
        <App />
      </ConnectedRouter>
    </ReduxProvider>
  </AppErrorBoundary>
);

if (window.Cypress) {
  window.store = store;
}
// These live in the context
store.dispatch(getUserFromSession());
store.dispatch(getViewPermissions());
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
